export default function PageTitle({ eyebrow, title, children }) {
  return (
    <section className="admin-title">
      <p className="eyebrow">{eyebrow}</p>
      <h1>{title}</h1>
      {children ? <p className="muted-text">{children}</p> : null}
    </section>
  );
}